import React, { ReactElement } from 'react';

import { Button, Link, Text } from '@philips-emr/tws-components';
import { ButtonTheme, Placement, ThemeTonalRange } from '@philips-emr/tws-constants';
import { Value } from '@philips-emr/tws-core';
import { ModalService } from '@philips-emr/tws-core/lib/services';
import { StatefulFragment } from '@philips-emr/tws-engine';
import { generateUUID } from '@philips-emr/tws-utils';

import { FragmentNames } from '../../codegen';

import { ProviderLegends } from './discredited-provider-controller';

export const LocationIcon: string = 'static/assets/DLS_Location.svg';
export const PhoneIcon: string = 'static/assets/DLS_Call.svg';
export const SiteIcon: string = 'static/assets/DLS_Global.svg';

export const BasePathAccreditation: string = '/static/assets/Acreditacao/';
export const IconsAccreditation: Map<string, string> = new Map([
  ['ieACBA', 'acba.png'],
  ['ieAdicq', 'adicq.png'],
  ['ieAIQG', 'aiqg.png'],
  ['ieAONA', 'aona.png'],
  ['ieApalc', 'apalc.png'],
  ['ieSpecialist', 'e.png'],
  ['ieNotivisa', 'n.png'],
  ['iePosGrad360', 'p.png'],
  ['ieQualiss', 'q.png'],
  ['ieResidency', 'r.png'],
]);

export const BasePath405: string = '/static/assets/405/';
export const Icons405: Map<string, string> = new Map([
  ['ieAccreditation', 'a.png'],
  ['ieDoctorate', 'd.png'],
  ['ieSpecialist', 'e.png'],
  ['ieOtherQualif', 'g.png'],
  ['ieISO', 'i.png'],
  ['ieMasters', 'm.png'],
  ['ieNotivisa', 'n.png'],
  ['iePosGrad360', 'p.png'],
  ['ieQualiss', 'q.png'],
  ['ieResidency', 'r.png'],
]);

export function mountIconsFor(render: Function, data: ProviderLegends, iconsArray: Map<string, string>, basePath: string): void {
  const btns: Array<ReactElement> = [];
  for (const key in data) {
    if (iconsArray.has(key) && data[(key as keyof ProviderLegends)] === 'S') {
      btns.push(getButton(`${basePath}${iconsArray.get(key)}`, 'c-custom-card-provider-info-button-padding'));
    }
  }
  render((): ReactElement => {
    return (
      <>{btns.map(element => { return (element); })}</>
    );
  }
  );
}

export function mountCardFragment(render: Function, contextData: Record<string, Value>): void {
  const uuid = generateUUID();

  const fragment = <StatefulFragment fragment={FragmentNames.DISCREDITED_PROVIDER_CARD_INFO} instanceUUID={uuid} uuid={uuid} contextData={contextData} />;
  render(() => {
    return (fragment);
  });
}

export function mountIconField(render: Function, iconPath: string, textValue: string): void {
  const icon = getButton(iconPath, 'c-custom-card-provider-info-button-size');
  const text = getText(textValue);
  render((): ReactElement => {
    return (
      <div className="c-container c-panel center-initial-flex-start-style">
        {icon}{text}
      </div>
    );
  }
  );
}

export function mountLinkField(render: Function, iconPath: string, textValue: string): void {
  const icon = getButton(iconPath, 'c-custom-card-provider-info-button-size');
  const link = getLink(textValue);
  render((): ReactElement => {
    return (
      <div className="c-container c-panel center-initial-flex-start-style">
        {icon}{link}
      </div>
    );
  }
  );
}

function getLink(value: string): ReactElement {
  return <Link
    value={value}
    route={value}
    className={'c-label-color-black-provider-info'}
  />;
}

function getText(value: string): ReactElement {
  return <Text
    value={value}
    key={value}
    className={'c-label-color-black-provider-info'}
  />;
}

function getButton(icon: string, className: string): ReactElement {
  return <Button
    key={icon}
    icon={icon}
    className={`c-custom-card-provider-info-button-svg ${className}`}
    theme={ButtonTheme.QUIET_DEFAULT}
    value={''}
    iconPlacement={Placement.LEFT}
    onClick={() => null}
    enabled={false}
  />;
}

export function mountDetailButton(key: string | number, legendsBasePath: string, render: Function): void {
  render((): ReactElement => {
    return (
      <Button
        key={key}
        theme={ButtonTheme.PRIMARY}
        value="hi.confirm"
        iconPlacement={Placement.LEFT}
        onClick={() => {
          ModalService.openDefault({
            closeable: true,
            fragment: FragmentNames.DISCREDITED_PROVIDERS_DIALOG,
            contextData: {
              key: key,
              legendsBasePath,
            },
            theme: ThemeTonalRange.ULTRA_LIGHT,
          });
        }}
        enabled={true}
      />
    );
  }
  );
}
